/**
 * Local read contract for booking lookup within BankDocuments feature.
 * Isolates BankDocuments UI from upstream Booking search DTO changes.
 */
export interface BankDocumentBookingLookup {
  id: number;
  offerName: string;
  companyName?: string | null;
  bookingDateFrom?: string;
  bookingDateTo?: string;
  numberOfParticipants: number;
  price: number;
}

export interface BankDocumentBookingLookupSource {
  id: number;
  offerName?: string | null;
  companyName?: string | null;
  bookingDateFrom?: string | null;
  bookingDateTo?: string | null;
  numberOfParticipants?: number | null;
  price?: number | null;
}

export const mapBookingToBankDocumentLookup = (
  booking: BankDocumentBookingLookupSource | undefined | null
): BankDocumentBookingLookup | undefined => {
  if (!booking) {
    return undefined;
  }

  return {
    id: booking.id,
    offerName: booking.offerName ?? `Booking #${booking.id}`,
    companyName: booking.companyName ?? null,
    bookingDateFrom: booking.bookingDateFrom ?? undefined,
    bookingDateTo: booking.bookingDateTo ?? undefined,
    numberOfParticipants: booking.numberOfParticipants ?? 0,
    price: booking.price ?? 0,
  };
};